var _path, _path2, _defs;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgUploadHighSpeed(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 250,
    height: 101,
    viewBox: "0 0 250 101",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M104.975 0.5C124.544 0.500088 141.476 11.7864 149.612 28.2041L149.836 28.6553L150.286 28.4287C152.985 27.0681 156.035 26.3008 159.266 26.3008C170.295 26.3009 179.236 35.2389 179.236 46.2637C179.236 46.4076 179.234 46.552 179.23 46.6973L179.22 47.208H185.743C200.336 47.208 212.167 59.0339 212.167 73.6211C212.167 88.2081 200.336 100.033 185.743 100.033H64.2559C49.6628 100.033 37.8332 88.2081 37.833 73.6211C37.833 62.3282 44.9232 52.689 54.8984 48.9121L55.209 48.7939L55.2207 48.4619C56.1709 21.8129 78.0828 0.5 104.975 0.5Z",
    stroke: "url(#paint0_linear_280_24968)"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M133.206 81.3013C133.758 81.3013 134.206 81.749 134.206 82.3013V82.5229C134.206 83.0752 133.758 83.5229 133.206 83.5229H117.429C116.876 83.5229 116.429 83.0752 116.429 82.5229V82.3013C116.429 81.749 116.876 81.3013 117.429 81.3013H133.206ZM133.206 74.6343C133.758 74.6343 134.206 75.082 134.206 75.6343V78.0786C134.206 78.6309 133.758 79.0786 133.206 79.0786H117.429C116.876 79.0786 116.429 78.6309 116.429 78.0786V75.6343C116.429 75.082 116.876 74.6343 117.429 74.6343H133.206ZM133.206 65.7456C133.758 65.7456 134.206 66.1933 134.206 66.7456V71.4116C134.206 71.9639 133.758 72.4116 133.206 72.4116H117.429C116.876 72.4116 116.429 71.9639 116.429 71.4116V66.7456C116.429 66.1933 116.876 65.7456 117.429 65.7456H133.206ZM124.61 37.564C125.001 37.1734 125.634 37.1734 126.024 37.564L144.464 56.0034C144.778 56.3184 144.555 56.8567 144.11 56.8569H134.206V62.5229C134.206 63.0752 133.758 63.5229 133.206 63.5229H117.429C116.876 63.5229 116.429 63.0752 116.429 62.5229V56.8569H106.524C106.079 56.8569 105.856 56.3184 106.171 56.0034L124.61 37.564Z",
    fill: "url(#paint1_linear_280_24968)"
  })), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint0_linear_280_24968",
    x1: 125,
    y1: 0,
    x2: 125,
    y2: 100.534,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#B59AF0"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#71F6FF"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint1_linear_280_24968",
    x1: 125.317,
    y1: 55.4384,
    x2: 125.317,
    y2: 83.5229,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#7DDFBB"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#7DDFBB",
    stopOpacity: 0.4
  })))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgUploadHighSpeed);
export default __webpack_public_path__ + "static/media/upload-high-speed.0bf777fdc9791218723f7624a71ca401.svg";
export { ForwardRef as ReactComponent };